import React from "react";
import {Table} from "react-bootstrap";
import k1utils from "../../../../util/k1utils";

export function OrderInformation({data}) {
    return (
        <>
            <Table striped bordered hover>
                <thead className="thead-dark">
                    <tr>
                        <th>주문서</th>
                        <th>선택</th>
                    </tr>
                </thead>
                <tbody>
                {data.order_value.sort(function (a, b) {
                    return a.t_order_itemidx - b.t_order_itemidx
                }).map((item, i) => {
                        if (item.t_order_item_name === "배송 여부") return false;
                        // return (
                        //     <div className="d-flex flex-wrap align-items-center border px-1" key={"order_value-" + i}>
                        //         <div className="d-flex flex-column flex-grow-1 my-lg-0 py-2 pr-3">
                        //     <span
                        //         className="text-dark-75 font-weight-bolder text-hover-primary font-size-lg"
                        //     >
                        //         {item.t_order_item_name}
                        //     </span>
                        //         </div>
                        //
                        //         <div className="d-flex align-items-center py-lg-0 py-2">
                        //             <div className="d-flex flex-column text-right">
                        //     <span
                        //         className="text-dark-75 font-weight-bolder text-hover-primary font-size-lg"
                        //     >
                        //     {item.t_item_option_name + (item.t_item_suboption_name ? `-${item.t_item_suboption_name}` : '') || item.direct_text}
                        //    </span>
                        //             </div>
                        //         </div>
                        //     </div>
                        // )
                        return (
                            <tr key={"order_value-"+i}>
                                <td>{item.t_order_item_name}</td>
                                <td>
                                    {item.t_item_option_name + (item.t_item_suboption_name ? `-${item.t_item_suboption_name}` : '') || item.direct_text || "Y"}
                                </td>
                            </tr>
                        )
                    }
                )}

                </tbody>
            </Table>


            {data.is_delivery === "Y" &&
            <Table striped bordered hover>
                <thead className="thead-dark">
                <tr>
                    <th>받는사람</th>
                    <th>전화번호</th>
                    <th>주소</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>{data.order_delivery.to_name}</td>
                    <td>{k1utils.phoneNumberFormat(data.order_delivery.phone_number)}</td>
                    <td> {`(${data.order_delivery.zipcode})`} <br/>
                         {`${data.order_delivery.address1} ${data.order_delivery.address2 ? data.order_delivery.address2 : ''}`}</td>
                </tr>
                </tbody>
            </Table>
            }
        </>
    )
}